import { lighten } from 'polished';
import { Grid, Column, Card, Paragraph, SubTitle, Title } from '@bidalihq/ui';
import { MessageCircle } from '@styled-icons/feather/MessageCircle';
import Link from 'next/link';
import tw from 'tailwind-styled-components';

import { colors } from '@/themes';
import Section from '@/components/section';

const CardContent = tw.div`
  flex
  items-center
`;

const Hero = () => {
  return (
    <Section backgroundColor={lighten(.35, colors.brand.primary)}>
      <Grid columns={2}>
        <Column span={[2, 2, 1]}>
          <Title className="text-brand-primary">Bidali Policies</Title>
          <SubTitle>Our policies and procedures</SubTitle>
          <Card>
            <CardContent>
              <MessageCircle className="mr-4" color={colors.typography.subtle} size={48} />
              <Paragraph className="my-0">Have a question about any of our policies and procedures? <Link href="/contact">Contact us</Link>.</Paragraph>
            </CardContent>
          </Card>
        </Column>
      </Grid>
    </Section>
  );
};

export default Hero;
